export default __webpack_public_path__ + "static/media/freeze.7634b397.png";